import { jsx } from 'react/jsx-runtime';
import React__default, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import { TabsContext } from '../Tabs.Context/Tabs.Context.es.js';

const TabsItem = /*#__PURE__*/ React__default.forwardRef(({ children, id, onClick, ...props }, ref)=>{
    const { current, variant } = useContext(TabsContext);
    const [theme, name] = variant.split('/');
    const selected = id === current;
    const handleClick = useCallback(()=>{
        onClick?.(id);
    }, [
        id,
        onClick
    ]);
    return jsx("li", {
        ref: ref,
        className: classNames('cb-tabs-item', theme, name, {
            selected
        }),
        onClick: handleClick,
        ...props,
        children: children
    });
});
TabsItem.displayName = 'Tabs.Item';

export { TabsItem };
//# sourceMappingURL=Tabs.Item.es.js.map
